import React, { Component } from 'react'
import ReactGA from 'react-ga'
import { detectPassiveEventSupport, hh } from '../../helpers'
import SectionWrapper from '../../Components/SectionWrapper'
import { throttle } from 'lodash'
import classnames from 'classnames'

class Home extends Component {
  constructor(props) {
    super(props)
    this.state = {
      mapLock: 'relative',
      currentMapIndex: 0,
      currentSectionKey: this.props.content[0].key,
      alertIsOpen: false,
      isModalOpen: false,
      vidPlay: false
    }
    this.mounted = false
    this.ticking = false
    this.lastScrollY = 0
    this.numSlides = 0
    this.props.content.forEach(s => {
      if (s.key === 'mapStory') {
        this.numSlides = s.steps.length
      }
    })
    this.sectionList = this.props.content
  }

  componentWillMount = () => {
    this.mounted = true
    window.scrollTo(0, 0)
    const options = { passive: detectPassiveEventSupport() }
    window.addEventListener('scroll', this.onScroll, options)
  }

  componentWillUnmount = () => {
    this.mounted = false
    window.removeEventListener('scroll', throttle(this.onScroll, 30))
  }

  componentDidMount = () => {
    this.mounted = true
    setTimeout(() => {
      this.setState({ alertIsOpen: true })
    }, 5000)
    this.setState({ vidPlay: true })
    this.update()
  }

  updateMapStickiness = (y, startY, stopY) => {
    y = y + hh // add header height
    let mapLock = 'pinTop'
    // if above map section
    mapLock = y < startY ? 'pinTop' : mapLock
    // if in map section
    mapLock = y > startY && y <= stopY ? 'sticky' : mapLock
    // if below map section
    mapLock = y >= stopY ? 'pinBottom' : mapLock
    if (mapLock !== this.state.mapLock) {
      this.setState({ mapLock })
    }
  }

  updateMapStoryIndex = (y, mapStorySection, startY, stopY) => {
    if (y > startY && y <= stopY) {
      const offset = hh + 300
      const userY = y - startY + offset
      const trackLength = mapStorySection.height
      const currentMapIndex = Math.floor((userY / trackLength) * this.numSlides)
      if (currentMapIndex !== this.state.currentMapIndex) {
        this.setState({ currentMapIndex })
      }
    }
  }

  announceHeight = (referenceKey, index, height, fromTop) => {
    const newSectionList = [...this.sectionList]
    newSectionList[index].height = height
    newSectionList[index].fromTop = fromTop
    this.sectionList = newSectionList
  }

  announceCurrentSection = (y, sections) => {
    const currentSection = sections.filter(
      (s, i) => y > s.fromTop && y < s.fromTop + s.height
    )
    if (currentSection[0]) {
      const currentSectionKey = currentSection[0].key
      if (currentSectionKey !== this.state.currentSectionKey) {
        this.setState({ currentSectionKey })
      }
    }
  }

  update = () => {
    if (!this.mounted) {
      return
    }
    const sections = this.sectionList
    const lastScrollY = this.lastScrollY
    // const iw = window.innerWidth
    const ih = window.innerHeight
    sections.forEach(s => {
      if (s.key === 'mapStory') {
        // this is tricky and has to match the css
        const startY = s.fromTop
        const stopY = startY + (this.numSlides - 1) * ih
        this.updateMapStickiness(lastScrollY, startY, stopY)
        this.updateMapStoryIndex(lastScrollY, s, startY, stopY)
      }
    })

    this.props.updateHeaderStyle(lastScrollY, sections)
    this.announceCurrentSection(lastScrollY, sections)
    this.ticking = false
  }

  // don't try to do stuff when stuff is already happening
  requestTick = () => {
    if (!this.ticking) {
      window.requestAnimationFrame(this.update)
      this.ticking = true
    }
  }

  onScroll = () => {
    this.lastScrollY = window.scrollY
    this.requestTick()
  }

  handleMailinglistClicked = () => {
    ReactGA.event({
      category: 'cta_click',
      action: 'alert_mailing_list'
    })
  }

  render() {
    const { mapLock, currentMapIndex, currentSectionKey, vidPlay } = this.state
    const sections = this.props.content.map((section, index) => {
      const Child = section.component
      switch (section.key) {
        case 'mapStory':
          return (
            <SectionWrapper
              index={index}
              key={section.key}
              announceHeight={this.announceHeight}
              color={section.color}
              shadow={section.shadow}
              referenceKey={section.key}
              child={
                <Child
                  vidPlay={vidPlay}
                  content={section}
                  mapLock={mapLock}
                  currentMapIndex={currentMapIndex}
                  currentSectionKey={currentSectionKey}
                />
              }
            />
          )
        case 'hero':
          return (
            <SectionWrapper
              index={index}
              key={section.key}
              announceHeight={this.announceHeight}
              color={section.color}
              shadow={section.shadow}
              referenceKey={section.key}
              child={
                <Child
                  content={section}
                  isModalOpen={this.props.isModalOpen}
                  openModal={this.props.openModal}
                  closeModal={this.props.closeModal}
                  vidPlay={vidPlay}
                  currentSectionKey={currentSectionKey}
                />
              }
            />
          )
        default:
          return (
            <SectionWrapper
              index={index}
              key={section.key}
              announceHeight={this.announceHeight}
              color={section.color}
              shadow={section.shadow}
              referenceKey={section.key}
              child={
                <Child
                  content={section}
                  currentSectionKey={currentSectionKey}
                  vidPlay={vidPlay}
                />
              }
            />
          )
      }
    })
    return (
      <div>
        {sections}
        <Alert
          isOpen={this.state.alertIsOpen}
          handleClose={() => this.setState({ alertIsOpen: false })}
          handleMailinglistClicked={this.handleMailinglistClicked}
        />
      </div>
    )
  }
}

const Alert = ({ isOpen, handleClose, handleMailinglistClicked }) => {
  const alertClasses = classnames({
    alertIsOpen: isOpen,
    alertIsClosed: !isOpen,
    alert: true
  })
  return (
    <div className={alertClasses}>
      <button onClick={handleClose}>{'×'}</button>
      <h3>{'Join the Community'}</h3>
      <a
        target={'_blank'}
        href={'https://upscri.be/b845ab/'}
        onClick={handleMailinglistClicked}
      >
        {'Join Our Mailing List'}
      </a>
      <a
        target={'_blank'}
        href={'https://map.foam.space/'}
        onClick={() =>
          ReactGA.event({
            category: 'cta_click',
            action: 'alert_start_mapping'
          })
        }
      >
        {'Start Mapping'}
      </a>
    </div>
  )
}

export default Home



// WEBPACK FOOTER //
// ./src/Views/Home/Home.js